<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Class Bookings</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            class="btn add-btn"
            @click="
              $router.push({
                name:
                  tokenObj.UserType == userTypeMainAdmin
                    ? 'mainAdminClassBookingAdd'
                    : 'schoolAdminClassBookingAdd',
              })
            "
          >
            <i class="fa fa-plus"></i>Add Class Booking
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row row-filter-1">
      <div
        class="form-group col-md-3"
        v-if="tokenObj.UserType == userTypeMainAdmin"
      >
        <label><b>School</b></label>
        <select class="form-control" v-model="schoolId">
          <option value>All</option>
          <option v-for="item in schools" :value="item.Id" :key="item.Id">
            {{ item.Name }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-9">
        <label><b>Class (Filter)</b></label>
        <div class="form-row">
          <div class="col-md-4">
            <select class="form-control" v-model="subjectName">
              <option value>All Class Subjects</option>
              <option
                v-for="(item, i) in displayedSubjects"
                :value="item"
                :key="i"
              >
                {{ item }}
              </option>
            </select>
          </div>
          <div class="col-md-4 mt-2 mt-md-0 mt-lg-0">
            <select class="form-control" v-model="subjectLevelName">
              <option value>All Subject Levels</option>
              <option
                v-for="(item, i) in displayedSubjectLevels"
                :value="item"
                :key="i"
              >
                {{ item }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-2 mt-md-0 mt-lg-0">
            <select class="form-control" v-model="duration">
              <option value>All Durations</option>
              <option
                v-for="(item, i) in durations"
                :value="item.Duration"
                :key="i"
              >
                {{ item.Duration }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-filter-2">
      <div class="form-group col-md-3">
        <label><b>Make-up Class (Filter)</b></label>
        <select class="form-control" v-model="makeupClass">
          <option value>All</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
      <div class="form-group col-md-4">
        <label><b>Student Name</b></label>
        <input
          type="text"
          placeholder="Search Name Here"
          class="form-control"
          v-model="studentName"
        />
      </div>
      <div class="form-group col-md-4">
        <label><b>Instructor Name</b></label>
        <input
          type="text"
          placeholder="Search Name Here"
          class="form-control"
          v-model="instructorName"
        />
      </div>
    </div>
    <div class="row row-filter-3">
      <div class="form-group col-md-2 date-div fit-content">
        <label><b>Start Date</b></label>
        <input type="date" class="form-control" v-model="startDate" />
      </div>
      <div
        class="form-group col-md-2 date-div fit-content pl-3 pl-md-0 pl-lg-0"
      >
        <label><b>End Date</b></label>
        <input
          type="date"
          class="form-control"
          v-model="endDate"
          :min="startDate"
        />
      </div>
      <div class="form-group col-md-9 time-status-div">
        <label><b>Class Time (Filter)</b></label>
        <div class="form-row">
          <div class="col-md-4 fit-content">
            <label>Start Time</label>
            <div class="d-flex align-items-center">
              <input
                type="number"
                class="form-control fit-content"
                v-model="startTimeHour"
                max="12"
                min="1"
                maxlength="2"
                placeholder="00"
                :required="startTimeMinute != ''"
              />
              <span class="mx-1">:</span>
              <input
                type="number"
                class="form-control fit-content"
                v-model="startTimeMinute"
                max="59"
                min="0"
                maxlength="2"
                placeholder="00"
              />
              <select
                v-model="startTimePart"
                class="form-control ml-2 fit-content"
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
          <div
            class="col-md-4 mt-2 mt-md-0 mt-lg-0 fit-content ml-0 ml-md-2 ml-lg-2"
          >
            <label>End Time</label>
            <div class="d-flex align-items-center">
              <input
                type="number"
                class="form-control fit-content"
                v-model="endTimeHour"
                max="12"
                min="1"
                maxlength="2"
                placeholder="00"
                :required="endTimeMinute != ''"
              />
              <span class="mx-1">:</span>
              <input
                type="number"
                class="form-control fit-content"
                v-model="endTimeMinute"
                max="59"
                min="0"
                maxlength="2"
                placeholder="00"
              />
              <select
                v-model="endTimePart"
                class="form-control ml-2 fit-content"
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
          <div
            class="col-md-4 mt-3 mt-md-0 mt-lg-0 status-div ml-0 ml-md-3 ml-lg-3"
          >
            <label><b>Status</b></label>
            <multiselect
              v-model="statuses"
              :options="statusList"
              :multiple="true"
            ></multiselect>
          </div>
          <div class="col-md-1 mt-2 mt-md-0 mt-lg-0 ml-0 ml-md-3 ml-lg-3">
            <button class="btn btn-primary filter-btn" @click="search">
              View
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- List and Calendar Format Toggle -->
    <div class="row row-filter-4">
      <div
        class="col-12 my-auto text-center text-lg-right text-md-right format-div"
      >
        <button
          title="List format"
          :class="format == 'list' ? 'btn bg-blue' : 'btn bg-white'"
          @click="showListFormat()"
        >
          <i class="fas fa-list-ul"></i>
        </button>
        <button
          title="Calendar format"
          :class="format == 'calendar' ? 'btn bg-blue' : 'btn bg-white'"
          @click="showCalendarFormat()"
        >
          <i class="far fa-calendar-alt"></i>
        </button>
      </div>
    </div>
    <!-- /List and Calendar Format Toggle -->

    <!-- Table Result -->
    <list-format
      v-if="format == 'list'"
      :schoolId="schoolId"
      :subjectName="subjectName"
      :subjectLevelName="subjectLevelName"
      :duration="duration"
      :makeupClass="makeupClass"
      :studentName="studentName"
      :instructorName="instructorName"
      :startDate="startDate"
      :endDate="endDate"
      :startTimeHour="startTimeHour"
      :startTimeMinute="startTimeMinute"
      :startTimePart="startTimePart"
      :endTimeHour="endTimeHour"
      :endTimeMinute="endTimeMinute"
      :endTimePart="endTimePart"
      :statuses="statuses"
      :key="counterList"
    ></list-format>
    <calendar-format
      v-if="format == 'calendar'"
      :schoolId="schoolId"
      :subjectName="subjectName"
      :subjectLevelName="subjectLevelName"
      :duration="duration"
      :makeupClass="makeupClass"
      :studentName="studentName"
      :instructorName="instructorName"
      :startDate="startDate"
      :endDate="endDate"
      :startTimeHour="startTimeHour"
      :startTimeMinute="startTimeMinute"
      :startTimePart="startTimePart"
      :endTimeHour="endTimeHour"
      :endTimeMinute="endTimeMinute"
      :endTimePart="endTimePart"
      :statuses="statuses"
      :key="counterCalendar"
    ></calendar-format>
    <!-- /Table Result -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import ListFormat from "./ClassBookingTableFormat.vue";
import CalendarFormat from "./ClassBookingCalendarFormat.vue";
import Multiselect from "vue-multiselect";
export default {
  components: {
    ListFormat,
    CalendarFormat,
    Multiselect,
  },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      schoolId: "",
      schools: [],
      subjectName: "",
      subjects: [],
      subjectLevelName: "",
      subjectLevels: [],
      duration: "",
      durations: [],
      makeupClass: "",
      studentName: "",
      instructorName: "",
      startDate: "",
      endDate: "",
      startTimeHour: "",
      startTimeMinute: "",
      startTimePart: "AM",
      endTimeHour: "",
      endTimeMinute: "",
      endTimePart: "AM",
      statuses: [],
      classBookings: "",
      format: "list",
      counterList: 0,
      counterCalendar: 0,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    statusList() {
      return ["Confirmed", "Pending Confirmation", "Cancelled"];
    },
    displayedSubjects() {
      if (this.schoolId || this.tokenObj.UserType != this.userTypeMainAdmin) {
        let schoolId =
          this.tokenObj.UserType != this.userTypeMainAdmin
            ? this.tokenObj.SchoolId
            : this.schoolId;
        let subjects = this.subjects.filter(
          (c) => c.SchoolId == schoolId || c.IsDefault == true
        );
        return [...new Set(subjects.map((c) => c.Name))];
      } else {
        return [...new Set(this.subjects.map((c) => c.Name))];
      }
    },
    displayedSubjectLevels() {
      if (this.schoolId || this.tokenObj.UserType != this.userTypeMainAdmin) {
        let schoolId =
          this.tokenObj.UserType != this.userTypeMainAdmin
            ? this.tokenObj.SchoolId
            : this.schoolId;
        let subjectLevels = this.subjectLevels.filter(
          (c) => c.SchoolId == schoolId || c.IsDefault == true
        );
        return [...new Set(subjectLevels.map((c) => c.Name))];
      } else {
        return [...new Set(this.subjectLevels.map((c) => c.Name))];
      }
    },
  },
  watch: {
    schoolId(val) {
      if (val) {
        this.subjectName = "";
        this.subjectLevelName = "";
      }
    },
  },
  methods: {
    showListFormat() {
      this.format = "list";
      this.$store.state.classBookingFilter.format = "list";
    },
    showCalendarFormat() {
      this.format = "calendar";
      this.$store.state.classBookingFilter.format = "calendar";
    },
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSubjects() {
      API.subject
        .getSubjectsForClassFilter({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjects = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSubjectLevels() {
      API.class
        .getSubjectLevelsForClassFilter({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjectLevels = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getDurations() {
      API.class
        .getDurationsForClassFilter({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.durations = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    search() {
      //set the state from filter
      this.$store.state.classBookingFilter.schoolId = this.schoolId;
      this.$store.state.classBookingFilter.subjectName = this.subjectName;
      this.$store.state.classBookingFilter.subjectLevelName =
        this.subjectLevelName;
      this.$store.state.classBookingFilter.duration = this.duration;
      this.$store.state.classBookingFilter.makeupClass = this.makeupClass;
      this.$store.state.classBookingFilter.studentName = this.studentName;
      this.$store.state.classBookingFilter.instructorName = this.instructorName;
      this.$store.state.classBookingFilter.startDate = this.startDate;
      this.$store.state.classBookingFilter.endDate = this.endDate;
      this.$store.state.classBookingFilter.startTimeHour = this.startTimeHour;
      this.$store.state.classBookingFilter.startTimeMinute =
        this.startTimeMinute;
      this.$store.state.classBookingFilter.startTimePart = this.startTimePart;
      this.$store.state.classBookingFilter.endTimeHour = this.endTimeHour;
      this.$store.state.classBookingFilter.endTimeMinute = this.endTimeMinute;
      this.$store.state.classBookingFilter.endTimePart = this.endTimePart;
      this.$store.state.classBookingFilter.statuses = this.statuses;
      //show result
      this.counterList++;
      this.counterCalendar++;
    },
  },
  created() {
    this.$store.state.class.classId = "";
    this.$store.state.class.date = "";
    this.$store.state.class.time = "";
    this.$store.state.class.instructorId = "";
    //populate the filter from state
    let classBookingFilter = this.$store.state.classBookingFilter;
    this.schoolId = classBookingFilter.schoolId;
    this.subjectName = classBookingFilter.subjectName;
    this.subjectLevelName = classBookingFilter.subjectLevelName;
    this.duration = classBookingFilter.duration;
    this.makeupClass = classBookingFilter.makeupClass;
    this.studentName = classBookingFilter.studentName;
    this.instructorName = classBookingFilter.instructorName;
    this.startDate = classBookingFilter.startDate;
    this.endDate = classBookingFilter.endDate;
    this.startTimeHour = classBookingFilter.startTimeHour;
    this.startTimeMinute = classBookingFilter.startTimeMinute;
    this.startTimePart = classBookingFilter.startTimePart;
    this.endTimeHour = classBookingFilter.endTimeHour;
    this.endTimeMinute = classBookingFilter.endTimeMinute;
    this.endTimePart = classBookingFilter.endTimePart;
    this.statuses = classBookingFilter.statuses;
    this.format = classBookingFilter.format
      ? classBookingFilter.format
      : "list";

    this.getSchools();
    this.getSubjects();
    this.getSubjectLevels();
    this.getDurations();
    if (this.format == "list") this.counterList++;
    else this.counterCalendar++;
  },
};
</script>

<style scoped>
.format-div {
  word-spacing: -10px;
}
.btn {
  border: 1px solid #ededed;
}
.bg-white {
  background-color: white;
  color: grey;
}
.bg-blue {
  background-color: #4b68e7;
  color: white;
}
@media (min-width: 768px) {
  .date-div {
    margin-top: 27px;
  }
  .time-status-div {
    -ms-flex: 0 0 70%;
    -webkit-box-flex: 0;
    flex: 0 0 70%;
    max-width: 70%;
  }
  .status-div {
    -ms-flex: 0 0 28%;
    -webkit-box-flex: 0;
    flex: 0 0 28%;
    max-width: 28%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassBookingList.vue